import React from 'react'
import ReactDOM from 'react-dom'

import { stringEmpty } from '../assets/utils'

export default class DropoffInformations extends React.Component {

  render() {
   return (
    <div className="col-12 informations">
      <div className="row">
        <div className="col-12">
          <h3 className="name">{(this.props.index ? this.props.index + ". " : "") + this.props.dropoff.name}</h3>
        </div>
        <div className="col-12">
          <span id="address">
            { stringEmpty(this.props.dropoff.line1) + ", " + stringEmpty(this.props.dropoff.zipcode) + " " + stringEmpty(this.props.dropoff.city) }
          </span>
        </div>
      </div>
    </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/components/components/DropoffInformations.jsx